// src/pages/GatePage.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';

export default function GatePage() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('gateToken');

    api.get('/gate/check', { params: { token } })
      .then(res => {
        localStorage.setItem('gateToken', res.data.token);

        if (res.data.status === 'ENTER') {
          navigate('/');
        }
        if (res.data.status === 'WAIT') {
          navigate('/wait');
        }
      });
  }, [navigate]);

  return <div>입장 확인 중...</div>;
}
